import { EnvActionType, IEnvUpdateAction } from '.';
import { IEnv } from '..';

/**
 * User initiates a search
 *
 * @param query
 */
export const EnvUpdateAction = (env: IEnv): IEnvUpdateAction => {
  return {
    type: EnvActionType.UPDATE_ENV,
    env
  };
};
